import { IconPropsType } from '..';

export const WorldFlag = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10391_28349)">
        <path
          d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
          fill="#00B4EF"
        />
        <path
          d="M12.18 2.29619C12.18 2.32419 12.18 2.36619 12.18 2.39419C12.166 2.67419 11.97 2.99619 11.69 2.95419C11.564 2.94019 11.452 2.84219 11.354 2.75819C11.13 2.57619 10.892 2.43619 10.612 2.33819C10.416 2.26819 10.206 2.22619 10.01 2.29619C9.74402 2.39419 9.78602 2.77219 10.066 2.81419L10.374 2.85619C10.556 2.89819 10.528 3.19219 10.374 3.29019C10.22 3.38819 10.024 3.34619 9.84202 3.31819C9.40802 3.22019 8.96002 3.12219 8.52602 3.03819C8.68002 2.80019 8.76402 2.52019 8.77802 2.24019C8.49802 2.10019 8.12002 2.38019 8.13402 2.68819C8.14802 2.84219 8.23202 2.98219 8.26002 3.12219C8.30202 3.27619 8.27402 3.45819 8.13402 3.52819C7.89602 3.65419 7.61602 3.29019 7.37802 3.41619C7.18202 3.51419 7.25202 3.82219 7.39202 4.00419C7.35002 4.01819 7.30802 4.03219 7.28002 4.04619C7.29402 4.06019 7.30802 4.08819 7.32202 4.10219C7.47602 4.27019 7.75602 4.20019 7.96602 4.14419C7.96602 4.14419 7.96602 4.14419 7.98002 4.14419C8.40002 4.04619 8.83402 4.24219 9.03002 4.63419C9.08602 4.76019 9.18402 4.85819 9.31002 4.91419C9.43602 4.97019 9.57602 4.98419 9.68802 5.04019C9.80002 5.11019 9.88402 5.22219 9.95402 5.34819C10.066 5.53019 10.346 5.48819 10.388 5.27819C10.43 5.08219 10.584 4.90019 10.794 4.88619C10.962 4.87219 11.116 4.98419 11.214 5.12419C11.354 5.33419 11.214 5.61419 10.962 5.62819H10.906C10.794 5.64219 10.71 5.71219 10.696 5.82419C10.682 5.93619 10.71 6.06219 10.71 6.17419C10.71 6.18819 10.71 6.18819 10.71 6.20219C10.668 6.63619 10.122 6.81819 9.82802 6.48219C9.73002 6.37019 9.63202 6.27219 9.54802 6.16019C9.43602 6.03419 9.26802 5.96419 9.10002 5.99219C9.05802 6.00619 9.00202 5.99219 8.96002 5.97819C8.83402 5.92219 8.76402 5.81019 8.70802 5.68419C8.56802 5.41819 8.44202 5.12419 8.40002 4.83019C8.37202 4.80219 8.34402 4.78819 8.31602 4.76019C8.10602 4.60619 7.81202 4.60619 7.56002 4.53619C7.44802 4.50819 7.35002 4.46619 7.25202 4.42419C7.23802 4.42419 7.22402 4.41019 7.21002 4.41019C6.94402 4.25619 6.63602 4.20019 6.34203 4.25619C6.00603 4.31219 5.67003 4.36819 5.36203 4.50819C4.84403 4.74619 4.43803 5.22219 4.28403 5.76819C4.15803 6.21619 4.22803 6.77619 4.60603 7.04219C4.88603 7.23819 5.26403 7.25219 5.55803 7.42019C5.99203 7.65819 6.18803 8.26019 5.97803 8.70819C5.81003 9.07219 5.78203 9.50619 5.57203 9.84219C5.46003 10.0102 5.30603 10.1502 5.19403 10.3322C5.05403 10.5702 5.02603 10.8642 4.99803 11.1582C4.97003 11.4522 4.95603 11.7882 5.15203 12.0122C5.33403 12.2222 5.65603 12.2642 5.93603 12.2222C6.21603 12.1802 6.48203 12.0822 6.76202 12.0682C7.19602 12.0402 7.64402 12.2222 8.06402 12.0822C8.61002 11.9142 8.86202 11.2982 9.31002 10.9622C9.60402 10.7382 9.98202 10.6402 10.332 10.5142C10.696 10.3742 11.074 10.1642 11.214 9.78619C11.228 9.74419 11.228 9.68819 11.214 9.64619C11.144 9.50619 10.948 9.59019 10.794 9.60419C10.612 9.61819 10.444 9.47819 10.36 9.31019C10.276 9.14219 10.262 8.94619 10.262 8.76419V8.75019C10.248 8.55419 10.528 8.51219 10.584 8.69419L10.612 8.80619C10.64 8.89019 10.654 8.97419 10.71 9.04419C10.864 9.22619 11.144 9.17019 11.368 9.10019C11.662 9.01619 12.012 8.84819 12.012 8.54019C12.012 8.33019 11.844 8.17619 11.732 7.99419C11.578 7.75619 11.886 7.49019 12.096 7.65819C12.474 7.93819 12.782 8.31619 12.978 8.75019C13.146 9.10019 13.23 9.52019 13.174 9.89819C13.16 9.99619 13.23 10.0662 13.3 10.0802C13.482 9.71619 13.636 9.32419 13.748 8.91819C14.42 6.51019 13.748 4.01819 12.18 2.29619Z"
          fill="url(#paint0_linear_10391_28349)"
        />
        <path
          d="M8.91795 0.265364C7.46195 -0.154636 5.97795 -0.0706364 4.64795 0.405364C4.68995 0.461364 4.73195 0.503364 4.78795 0.545364C5.22195 0.993364 5.86595 1.34336 6.45395 1.14736C6.94395 0.979364 7.26595 0.475364 7.76995 0.349364C7.90995 0.307364 8.04995 0.307364 8.18995 0.321364C8.42795 0.349364 8.39995 0.713364 8.16195 0.713364C7.93795 0.643364 7.82595 0.965364 8.03595 1.06336C8.49795 1.27336 9.02994 1.35736 9.54794 1.44136C9.79994 1.48336 10.0519 1.52536 10.2899 1.45536C10.4999 1.39936 10.6679 1.27336 10.8079 1.10536C10.2339 0.755364 9.60394 0.461364 8.91795 0.265364Z"
          fill="url(#paint1_linear_10391_28349)"
        />
        <path
          d="M0.140009 8.38634C0.168009 8.35834 0.196009 8.31634 0.224009 8.28834C0.350009 8.09234 0.392009 7.85434 0.490009 7.63034C0.588009 7.40634 0.770009 7.19634 1.00801 7.19634C1.02201 6.76234 1.34401 6.39834 1.70801 6.14634C1.82001 6.07634 1.94601 5.99234 1.97401 5.85234C2.03001 5.64234 1.79201 5.47434 1.66601 5.29234C1.45601 4.99834 1.51201 4.57834 1.59601 4.22834C1.66601 3.90634 1.73601 3.57034 1.80601 3.24834C1.84801 3.08034 1.87601 2.89834 1.96001 2.74434C2.03001 2.59034 2.14201 2.45034 2.24001 2.31034C2.36601 2.10034 2.43601 1.87634 2.49201 1.65234C1.45601 2.52034 0.672009 3.69634 0.266009 5.08234C-0.0419912 6.20234 -0.0839912 7.32234 0.140009 8.38634Z"
          fill="url(#paint2_linear_10391_28349)"
        />
        <path
          d="M9.26794 12.3754C9.35194 12.1794 9.09994 11.9974 8.93194 12.1514C8.87594 12.2074 8.81994 12.2494 8.74994 12.2774C8.56794 12.3754 8.35794 12.3894 8.16193 12.4314C7.96593 12.4734 7.75593 12.5714 7.67193 12.7534C7.60193 12.9074 7.85393 13.0054 8.00793 13.0054C8.17593 13.0054 8.32993 12.9214 8.48394 12.8514C8.62394 12.7954 8.77794 12.7534 8.91794 12.6834C9.05794 12.6134 9.18394 12.5154 9.26794 12.3754Z"
          fill="url(#paint3_linear_10391_28349)"
        />
        <path
          opacity="0.1"
          d="M12.502 2.6875C12.656 3.6675 12.614 4.7035 12.32 5.7255C11.256 9.4495 7.39198 11.5915 3.66798 10.5415C2.19798 10.1075 0.965984 9.2535 0.0839844 8.1195C0.503984 10.7095 2.37998 12.9635 5.06798 13.7195C8.77798 14.7835 12.656 12.6275 13.72 8.9035C14.364 6.6775 13.846 4.3815 12.502 2.6875Z"
          fill="black"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10391_28349"
          x1="4.22178"
          y1="5.94037"
          x2="13.8006"
          y2="8.67377"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E100" />
          <stop
            offset="1"
            stopColor="#DAFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10391_28349"
          x1="4.76541"
          y1="-0.0153481"
          x2="10.6416"
          y2="1.66146"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E100" />
          <stop
            offset="1"
            stopColor="#DAFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10391_28349"
          x1="0.363433"
          y1="4.75187"
          x2="2.1517"
          y2="5.26217"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E100" />
          <stop
            offset="1"
            stopColor="#DAFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10391_28349"
          x1="7.78953"
          y1="12.3281"
          x2="9.16767"
          y2="12.7214"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E100" />
          <stop
            offset="1"
            stopColor="#DAFF00"
          />
        </linearGradient>
        <clipPath id="clip0_10391_28349">
          <rect
            width="14"
            height="14"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
